import {
  PROVIDER_LABELS,
  PROVIDERS,
  PROVIDERS_LIST
} from 'helpers/constants/storeSettings';

export const isPlatformAlreadyUsed = (platform, allPriceAdjustments) => {
  return allPriceAdjustments.some((adj) => adj.ProviderName === platform);
};

export const getScopeName = (scope) => {
  if (scope === 'itemsAndModifiers') {
    return 'Items and Modifiers';
  }
  return 'Items';
};

export const getPlatformLabel = (providerName) => {
  return PROVIDER_LABELS[providerName] || providerName;
};

// Map UI platform names to backend format
export const mapPlatformNameToBackend = (platformName) => {
  const mapping = {
    UberEats: 'uber',
    DoorDash: 'doordash',
    GrubHub: 'grubhub',
    Slice: 'slice'
  };
  return mapping[platformName] || platformName;
};

// Map backend platform names to UI format
export const mapPlatformNameFromBackend = (platformName) => {
  const mapping = {
    uber: 'UberEats',
    doordash: 'DoorDash',
    grubhub: 'GrubHub',
    slice: 'Slice'
  };
  return mapping[platformName] || platformName;
};

// Map ProviderPriceRules platform names to backend format
export const mapProviderPriceRulesToBackend = (data) => {
  if (!data || !Array.isArray(data.ProviderPriceRules)) {
    return data;
  }
  return {
    ...data,
    ProviderPriceRules: data.ProviderPriceRules.map((rule) => ({
      ...rule,
      ProviderName: mapPlatformNameToBackend(rule.ProviderName)
    }))
  };
};

// Map ProviderPriceRules platform names from backend format to UI format
export const mapProviderPriceRulesFromBackend = (data) => {
  if (!data || !Array.isArray(data.ProviderPriceRules)) {
    return data;
  }
  return {
    ...data,
    ProviderPriceRules: data.ProviderPriceRules.map((rule) => ({
      ...rule,
      ProviderName: mapPlatformNameFromBackend(rule.ProviderName)
    }))
  };
};

export const buildProviderPriceRules = (itemData) => {
  const providersList = PROVIDERS_LIST;

  if (!Array.isArray(providersList) || !providersList.length) {
    return [];
  }

  const existingRules = Array.isArray(itemData?.ProviderPriceRules)
    ? [...itemData.ProviderPriceRules]
    : [];

  const byName = new Map(
    existingRules.map((rule) => [rule.ProviderName, rule])
  );

  providersList.forEach((code) => {
    const providerName = PROVIDER_LABELS[code];

    if (!byName.has(providerName)) {
      byName.set(providerName, {
        ProviderName: providerName,
        Price: itemData?.Price ?? 0,
        IsOverridden: false
      });
    }
  });

  // Sort order: UberEats, GrubHub, DoorDash, Slice
  const sortOrder = {
    UberEats: 1,
    GrubHub: 2,
    DoorDash: 3,
    Slice: 4
  };

  return Array.from(byName.values()).sort((a, b) => {
    const orderA = sortOrder[a.ProviderName] || 999;
    const orderB = sortOrder[b.ProviderName] || 999;
    return orderA - orderB;
  });
};
